import { ParsedUrlQuery } from "querystring";
import { useRouter } from "next/router";
import { StandardProps } from "@/components/componentMap.ts";
import { OnwardLinksESI } from "@/components/OnwardLinks/OnwardLinksESI.tsx";
import { useMonetateId } from "@/hooks/useMonetateId/useMonetateId.ts";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

export const EXCLUDED_BRANDS = [
  "apple",
  "chanel",
  "dior",
  "dyson",
  "montblanc",
];

export const validOnwardLinkTypes = {
  esiImageCards: "esi-image-cards",
  esiTextLinks: "esi-text-links",
};

export type FoundItProductPageLink = {
  AnchorText: string;
  DestinationUrl: string;
  ImageUrl: string;
  Order: number;
};

export function OnwardLinks({
  product,
  flags,
  configProps,
  runtimeConfig,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "flags" | "product" | "configProps" | "runtimeConfig" | "experiencesRawObject"
>) {
  const queryParams: ParsedUrlQuery = useRouter().query;
  const currentUrl = `https://www.johnlewis.com${useRouter().asPath.split("?")[0]}`;
  const isExcludedBrand =
    !product.brand?.name ||
    EXCLUDED_BRANDS.some(
      (item) => item.toLowerCase() === product.brand?.name.toLowerCase(),
    );
  const onwardLinkType =
    flags.onwardLinksType.value.toString() ||
    queryParams["onwardLinksType"]?.toString();
  const normalizedOnwardLinkType = onwardLinkType?.trim();
  const onwardLinkPosition = flags.onwardLinksPosition.value;
  const onwardLinkInView =
    parseFloat(flags.onwardLinksVisibilityThreshold.value.toString()) || 0;
  const threshold =
    onwardLinkInView < 0 || onwardLinkInView > 1 ? 0 : onwardLinkInView;
  const { monetateId } = useMonetateId();

  function handleMonetateActions() {
    recordImpressionByParam(
      runtimeConfig?.monetateEnvironment,
      experiencesRawObject,
      "pdp-scaffold-onward-links-in-view",
      "true",
      monetateId,
    );
    if (onwardLinkType) {
      dispatchMonetateQEvent("pdp:onwardlinks:cards-in-view");
    }
  }

  if (
    isExcludedBrand ||
    !normalizedOnwardLinkType ||
    !Object.values(validOnwardLinkTypes).includes(normalizedOnwardLinkType)
  ) {
    return null;
  }

  if (
    configProps?.onwardLinksPosition &&
    configProps.onwardLinksPosition != onwardLinkPosition &&
    configProps.onwardLinksPosition != undefined
  ) {
    return null;
  }

  return (
    <OnwardLinksESI
      onwardLinkType={normalizedOnwardLinkType}
      currentUrl={currentUrl}
      handleMonetateActions={handleMonetateActions}
      threshold={threshold}
    />
  );
}
